<div class="position-relative w-100 padding">

  <div class="main">
    <div class="container">
      <h1 class="h1 text-center mb-8px">โปรแกรมคำนวณภาษี เงินเดือนเท่านี้ เสียภาษีกี่บาท</h1>
      <p class="p1 text-center text-gray-medium mb-24px">กรอกเงินเดือนเพื่อให้โปรแกรม iTAX คำนวณภาษีเบื้องต้น</p>

      <div class="wrapper">
        <div class="box-wrapper mb-24px">
          <app-calculate-tax-box (finishedCalChange)="onCalChange($event)"></app-calculate-tax-box>
        </div>
        <p class="body-text text-gray-medium mb-0">โปรแกรมนี้ใช้สำหรับคำนวณภาษีเงินได้บุคคลธรรมดาเบื้องต้น โดยอ้างอิงตามกฎหมายภาษีปัจจุบัน ด้วยสมมติฐานว่ามีรายได้จากงานประจำทางเดียว <a href="https://www.itax.in.th/pedia/เงินได้ประเภทที่-1/" target="_blank">(เงินได้ประเภทที่ 1)</a> และมี<a href="https://www.itax.in.th/pedia/ค่าลดหย่อนส่วนตัว/" target="_blank">ค่าลดหย่อนส่วนตัว</a>เพียงรายการเดียว</p>
      </div>
    </div>
  </div>

  <div class="featured">
    <div class="container">
      <app-calculator-paystation-detail></app-calculator-paystation-detail>
    </div>
  </div>

  <div class="sub">
    <div class="container">
      <app-calculator-app-detail></app-calculator-app-detail>
    </div>
  </div>

</div>
